// root '../../../';

// dependencies
import { Child } from 'pym.js';
import Zion from './utils/Zion';

// polyfills
// import fetch from 'unfetch';
import './utils/polyfills'; // (includes Array.findIndex && Array.find)

// utils & graphic

// styles
import './styles/graphic.scss';

/* develblock:start */

import * as d3 from 'd3';
import { format } from 'd3-format';
import meta from './data/meta.json';
import { stylePremium } from './utils/helpers';
import { bandAxis, linearAxis } from '../../../factory/axes';

import './styles/graphic.scss';

// const d3 = {
//   json,
//   max,
//   min,
//   select,
//   timeFormat,
//   timeParse,
//   timeFormatDefaultLocale,
// };

// formatD3Time();
d3.timeFormatDefaultLocale({
  periods: ['a.m.', 'p.m.'],
  days: [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ],
  shortDays: ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'],
  months: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  shortMonths: [
    'Jan.',
    'Feb.',
    'March',
    'April',
    'May',
    'June',
    'July',
    'Aug.',
    'Sept.',
    'Oct.',
    'Nov.',
    'Dec.',
  ],
});

const fmtComma = format(',');
const fmtSI = format('.2s');
const fmtThou = format('~s');
const fmtPCT = format('~p');

const pkg = require('../package.json');

if (process.env.NODE_ENV === 'development') {
  console.clear();
}

let minValue;
let maxValue;

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ id: pkg.name });

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);

      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }

  const { pymChild } = window;
  pymChild.sendHeight();

  // If embedded, send Zion page view event
  if (window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
  }
};


const CNNPolitics = false;
const CNNBusiness = false;

stylePremium(CNNPolitics, CNNBusiness);

let data;

d3.json('https://ix.cnn.io/data/retail-sales/retail_sales.json').then((jsondata) => {
  // Parse and sort all data first
  const allData = jsondata.data.map(d => ({
    date: d3.timeParse('%Y-%m-%d')(d.date),
    amt: d.monthly_change,
    label: d3.timeFormat('%b')(d3.timeParse('%Y-%m-%d')(d.date)),
  }))
    .sort((a, b) => a.date - b.date);

  // Filter to last 24 months from the most recent data point
  const latestDate = d3.max(allData, d => d.date);
  const cutoffDate = new Date(latestDate);
  cutoffDate.setMonth(cutoffDate.getMonth() - 24);

  data = allData.filter(d => d.date >= cutoffDate);


  // Set min and max for y scale; add a bit of headroom
  minValue = Math.min(0, d3.min(data, d => d.amt));
  maxValue = d3.max(data, d => d.amt);

  // Update headline and dek
  d3.select('h2.dek').html(`${jsondata.summary} <br><br><span class="chart-title">Percentage change in retail sales, by month</span>`);

  d3.select('p#timestamp').html(`Notes: Figures are seasonally adjusted. Data current through ${jsondata.latestMonth} as of ${jsondata.lastUpdatedStr}.`);

  draw();
  window.onresize = draw;
});


function draw() {
  const container = d3.select('#graphic');
  container.html('');


  const initialWidth = container.node().clientWidth;
  const initialHeight = 400;
  const isMobile = initialWidth <= 500;
  const margins = {
    top: 20, right: 30, bottom: 25, left: isMobile ? 55 : 55,
  };

  const chartWidth = initialWidth - margins.left - margins.right;
  const chartHeight = initialHeight - margins.top - margins.bottom;

  // Create a time scale for x instead of using bandAxis
  const x = d3.scaleTime()
    .domain(d3.extent(data, d => d.date))
    .range([0, chartWidth]);

  // Linear scale for y remains the same
  const y = d3.scaleLinear()
    .domain([Math.min(0, minValue), maxValue])
    .range([chartHeight, 0])
    .nice();

  // Build x and y axes
  const xAxis = d3.axisBottom(x)
    .ticks(isMobile ? 6 : 6)
    .tickFormat(d3.timeFormat(isMobile ? '%b %y' : '%b %Y'))
    .tickSize(4)
    .tickPadding(4);

  const yAxis = d3.axisLeft(y)
    .ticks(isMobile ? 5 : 5)
    .tickSize(-(chartWidth + 20))
    .tickFormat(d => `${d}%`);

  // Create the SVG container
  const svg = container.append('svg')
    .attr('width', initialWidth)
    .attr('height', initialHeight);

  const g = svg.append('g')
    .attr('transform', `translate(${margins.left},${margins.top})`);

  // Draw the x axis
  g.append('g')
    .attr('class', 'x grid')
    .attr('transform', `translate(0,${chartHeight})`)
    .call(xAxis);

  // Draw the y axis with grid lines
  g.append('g')
    .attr('class', 'y grid')
    .attr('transform', 'translate(-20, 0)') // shift axis 20px to the left
    .call(yAxis);

  // Calculate a manual bar width since time scales don't offer bandwidth()
  const barWidth = (chartWidth / data.length) * 0.75;

  // Tooltip (HTML div, positioned relative to the chart container)
  const tooltip = container.append('div')
    .attr('class', 'tooltip')
    .style('display', 'none');

  // Draw the bars; center each bar on its date value
  const bars = g.append('g').attr('class', 'data');
  bars.selectAll('.bar')
    .data(data)
    .enter().append('rect')
    .attr('class', (d, i) => `bar ${i === data.length - 1 ? 'highlight' : ''} ${d.amt < 0 ? 'loss' : ''}`)
    .attr('x', d => x(d.date) - barWidth / 2)
    .attr('y', d => y(Math.round(d.amt * 10) / 10 > 0 ? Math.round(d.amt * 10) / 10 : 0))
    .attr('width', barWidth)
    .attr('height', d => Math.abs(y(Math.round(d.amt * 10) / 10) - y(0)))
    .on('mouseover', function onBarOver() {
      d3.select(this).classed('active', true);
      tooltip.style('display', 'block');
    })
    .on('mousemove', (d) => {
      const [mx, my] = d3.mouse(container.node());
      tooltip.html(`<strong>${d3.timeFormat('%b %Y')(d.date)}</strong><br>${d3.format('.1f')(d.amt)}%`);

      // Flip to the left of the cursor when there isn't room to the right,
      // so tooltips on the most recent (rightmost) bars don't run off the chart
      const tooltipWidth = tooltip.node().offsetWidth;
      const left = (mx + 12 + tooltipWidth > initialWidth)
        ? mx - tooltipWidth - 12
        : mx + 12;

      tooltip
        .style('left', `${left}px`)
        .style('top', `${my - 38}px`);
    })
    .on('mouseout', function onBarOut() {
      d3.select(this).classed('active', false);
      tooltip.style('display', 'none');
    });

  // Highlight the last bar with a label
  const lastData = data[data.length - 1];
  if (lastData) {
    g.append('text')
      .attr('class', 'label-halo')
      .attr('x', x(lastData.date))
      .attr('y', y(Math.round(lastData.amt * 10) / 10 > 0 ? Math.round(lastData.amt * 10) / 10 : 0) - 10)
      .attr('text-anchor', 'middle')
      .text(`${d3.format('.1f')(lastData.amt)}%`);
  }

  // Draw a zero line if needed
  if (y.domain()[0] < 0) {
    // Calculate the edges of the leftmost and rightmost bars
    const firstDate = data[0].date;
    const lastDate = data[data.length - 1].date;
    const leftEdge = x(firstDate) - barWidth / 2;
    const rightEdge = x(lastDate) + barWidth / 2;

    g.append('line')
      .attr('class', 'zero-bar')
      .attr('x1', leftEdge)
      .attr('x2', rightEdge)
      .attr('y1', y(0))
      .attr('y2', y(0));
  }

  window.pymChild.sendHeight();
  d3.select('#root').attr('class', 'ready');
}
